import React, { useEffect, useState, useMemo } from 'react';
import { formatDate, DATE_FORMAT } from '@shootsta/get-moment';
import _debounce from 'lodash.debounce';

import {
  getOptionValues,
  isAssetFileValid,
  appendMetadataToOption,
  isAllowedDownloadOption,
  transformKeysToOptionsArray,
  isAssetExists,
  canDownloadOriginalQuality,
  isVideoType,
  bytesToSize } from
'../utils';
import { Input, Text } from '../../../../../../ui-kit';
import AssetPreview from '../../../../../AssetPreview/containers/AssetPreview';
import CardItem from '../../../../../../ui-kit/components/List/components/Card/components/CardItem';

























const AssetList = ({
  assetId,
  getAssets,
  assetsMap,
  isDescriptionForm = false,
  description,
  handleChangeCustomAssetDescription,
  handleDeleteCustomAssets,
  handleOpenAssetDetailsModal,
  organisationId,
  handleRemoveAssetFromProject,
  canUpdateVideo
}) => {
  const [assetDetails, setAssetDetails] = useState();
  const currentAsset = assetsMap && assetDetails && assetDetails.assetId ?
  assetsMap.get(assetDetails.assetId) || assetDetails :
  assetDetails;

  const getAssetDetails = async () => {
    const { data } = await getAssets({ organisationId, assetIds: assetId });
    setAssetDetails(data.getAssets[0]);
  };

  const changeHandler = (value) => {
    if (isDescriptionForm && handleChangeCustomAssetDescription) {
      handleChangeCustomAssetDescription(assetId, value);
    }
  };

  const debouncedChangeHandler = useMemo(
    () => _debounce(changeHandler, 300),
    []);

  // Stop the invocation of the debounced function
  // after unmounting
  useEffect(() => () => {
    debouncedChangeHandler.cancel();
  }, []);

  useEffect(() => {
    getAssetDetails();
  }, [assetId]);

  if (!assetDetails) {
    return null;
  }

  const {
    title,
    metaData,
    createdAt,
    assetFiles
  } = assetDetails;

  const getDownloadOptions = () => {
    if (!assetDetails || !assetFiles) {
      return [];
    }

    const assetFilesKeys = [...Object.keys(assetFiles)];

    const isVideo = isVideoType(metaData);

    const downloadOptions1 = assetFilesKeys.
    filter(isAssetExists(assetDetails)).
    filter(() => !isVideo || canDownloadOriginalQuality(assetDetails)).
    filter((assetFileKey) => !isVideo || isAllowedDownloadOption()(assetFileKey));

    const downloadOptions2 = downloadOptions1.
    reduce(transformKeysToOptionsArray(assetDetails), []).
    map(appendMetadataToOption).
    filter(isAssetFileValid).
    filter(({ type }) => !type || type !== 'VTT_CAPTION').
    map((assetFile) => getOptionValues(assetFile));

    return downloadOptions2;
  };

  const options = getDownloadOptions();

  const handleDownload = () => {
    window.open(options[0].sourceUrl);
  };


  if (isDescriptionForm) {
    return (
      <div className="assetlist">
        <Text className="title" body highlighted>{title}</Text>
        <Text>Additional Info</Text>
        <Input
          defaultValue={description}
          value={description}
          onChange={(e) => debouncedChangeHandler(e)}
          readOnly={!canUpdateVideo} />

      </div>);

  }

  const ACTIONS_OPTIONS = [
  {
    label: 'Asset Details',
    action: () => handleOpenAssetDetailsModal && handleOpenAssetDetailsModal(assetId)
  },
  { label: 'Download', action: handleDownload },
  { separator: true },
  { label: 'Remove from Project', action: () => handleRemoveAssetFromProject && handleRemoveAssetFromProject(assetId) },
  { label: 'Delete', action: () => handleDeleteCustomAssets && handleDeleteCustomAssets(assetId), isRed: true }];


  const overlayProps = {
    more: {
      options: ACTIONS_OPTIONS,
      color: 'white'
    }
  };

  return (
    <CardItem
      overlayProps={canUpdateVideo ? overlayProps : null}
      forceInteractive
      className="voice-over__upload-section--attachments__list-item">

      <AssetPreview
      // canPlayAudio
      asset={currentAsset}
      hideFileTypeIcon
      darkMode
      height={138} />

      <div className="voice-over__upload-section--attachments__list-item--content">
        <Text label ellipsisOverflow>{title}</Text>
        <div className="voice-over__upload-section--attachments__list-item--content__bottom">
          <Text caption>{formatDate(createdAt, DATE_FORMAT.MONTH_SHORT_DAY_YEAR)}</Text>
          <Text caption>{bytesToSize(JSON.parse(metaData).size)}</Text>
        </div>
      </div>
    </CardItem>);

};

export default AssetList;